import jwtDecode from 'jwt-decode';

import { User, UserFromToken } from '~/types';

import { LocaleCode } from '../types';

export function decodeUser(jwt: string): User | undefined {
  try {
    const rawUser = jwtDecode<UserFromToken>(jwt);
    return {
      id: rawUser.id,
      exp: rawUser.exp,
      organization: rawUser.organisation,
      confirmed: rawUser.confirmed,
      locale: rawUser.locale.toLowerCase() as LocaleCode,
      email: rawUser.email,
    };
  } catch (e) {
    console.error('Found a token but failed to decode it', e);
    return;
  }
}
